import { useMutation } from "@tanstack/react-query";
import { useI18n } from "i18n";
import { Errors, trackError } from "modules/monitoring";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { IEmailCustomization } from "../../types";
import { sendTestEmailRequest } from "./request";

interface Options {
  onSuccess?: () => void;
}

export const useSendTestEmail = (
  eventId: string | undefined,
  options: Options = {},
) => {
  const { onSuccess } = options;
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();
  const { t } = useI18n(["eventForm", "common"]);

  const {
    mutateAsync: sendTestEmail,
    isPending: isSending,
    status,
  } = useMutation({
    mutationFn: async (customization: IEmailCustomization) => {
      if (!eventId) {
        throw new Error("Event ID is required");
      }
      return await sendTestEmailRequest(eventId, customization);
    },
    onSuccess: () => {
      addSuccessNotification({
        message: t("eventForm:customize.emails.test.email.sent"),
        autoDismiss: 5,
      });

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: Error) => {
      trackError(error, {
        label: Errors.EMAIL_CUSTOMIZATION_TEST_EMAIL_SEND,
      });
      addErrorNotification({
        message: t("eventForm:customize.emails.send.test.email.error.message"),
      });
    },
  });

  return {
    sendTestEmail,
    isSending,
    status,
  };
};
